import { useState } from 'react';
import { toast } from 'sonner';
import { Send } from 'lucide-react';
import { api } from '../lib/api';

const FIELDS = [
  { name: 'name', label: 'Name', type: 'text', required: true, testid: 'enquiry-name-input' },
  { name: 'email', label: 'Email', type: 'email', required: true, testid: 'enquiry-email-input' },
  { name: 'phone', label: 'Phone', type: 'tel', required: false, testid: 'enquiry-phone-input' },
  { name: 'organisation', label: 'Organisation', type: 'text', required: false, testid: 'enquiry-organisation-input' },
];

export default function EnquiryForm({ testidPrefix = 'enquiry' }) {
  const [form, setForm] = useState({ name: '', email: '', phone: '', organisation: '', message: '' });
  const [sending, setSending] = useState(false);

  const update = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (sending) return;
    setSending(true);
    try {
      await api.sendEnquiry(form);
      toast.success('Enquiry submitted! Team KROY will reach out soon.');
      setForm({ name: '', email: '', phone: '', organisation: '', message: '' });
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Could not submit. Please try again.');
    } finally {
      setSending(false);
    }
  };

  const inputCls =
    'w-full bg-[#0d0d0d] border border-white/10 rounded-lg px-4 py-3 text-sm text-white placeholder:text-[#5c5c5c] outline-none focus:border-[#e8173a]/60 focus:ring-2 focus:ring-[#e8173a]/20 transition-all duration-200';

  return (
    <form onSubmit={submit} className="card-surface p-6 sm:p-8 space-y-5" data-testid={`${testidPrefix}-form`}>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        {FIELDS.map((f) => (
          <div key={f.name}>
            <label className="block text-xs font-semibold uppercase tracking-wider text-[#8a8a8a] mb-2">
              {f.label}
              {f.required && <span className="text-[#e8173a] ml-1">*</span>}
            </label>
            <input
              data-testid={f.testid}
              name={f.name}
              type={f.type}
              required={f.required}
              value={form[f.name]}
              onChange={update}
              placeholder={f.label}
              className={inputCls}
            />
          </div>
        ))}
      </div>
      <div>
        <label className="block text-xs font-semibold uppercase tracking-wider text-[#8a8a8a] mb-2">
          Message<span className="text-[#e8173a] ml-1">*</span>
        </label>
        <textarea
          data-testid="enquiry-message-input"
          name="message"
          required
          rows={4}
          value={form.message}
          onChange={update}
          placeholder="Tell us about your collaboration idea..."
          className={`${inputCls} resize-none`}
        />
      </div>
      <button
        data-testid="enquiry-submit-button"
        type="submit"
        disabled={sending}
        className="w-full inline-flex items-center justify-center gap-2 bg-[#e8173a] hover:bg-[#c0102e] disabled:opacity-60 text-white text-sm font-extrabold uppercase tracking-wider px-6 py-4 rounded-lg transition-all duration-300 hover:shadow-[0_15px_40px_-12px_rgba(232,23,58,0.6)] active:scale-[0.98]"
      >
        <Send className="w-4 h-4" strokeWidth={2.5} />
        {sending ? 'Sending...' : 'Send Enquiry'}
      </button>
    </form>
  );
}
